'use strict';

angular.module('msCommunity', ['msUtility', 'msCore']).config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state('community', {
    abstract: true,
    url: '/community',
    templateUrl: 'community/pages/community-base.html',
    data: {
      pageTitle: 'pageTitles.community'
    }
  }).state('community.home', {
    url: '',
    templateUrl: 'community/pages/community-home.html',
    controller: 'CommunityHomeCtrl',
    controllerAs: 'vm',
    resolve: {
      topics: ['discussionSvc', function (discussionSvc) {
        return discussionSvc.getTopics();
      }]
    }
  }).state('community.discussion', {
    abstract: true,
    url: '/activity/:activity',
    template: '<div ui-view></div>',
    resolve: {
      activity: ['$stateParams', 'discussionSvc', 'NotifyingSvc', function ($stateParams, discussionSvc, NotifyingSvc) {
        return discussionSvc.getActivityDiscussions($stateParams.activity).then(function (activity) {

          NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.PAGE_TITLE, {
            pageTitle: 'Discussing "' + activity.title + '"'
          });
          // Remove flagged comments from each discussion
          _.each(activity.discussions, function (discussion) {
            discussion.comments = _.filter(discussion.comments, function (comment) {
              return comment.status !== 'FLAGGED';
            });
          });
          if (!activity.promotedWidget) {
            throw Error('Activity not discussable');
          }
          return activity;
        });
      }]
    }
  }).state('community.discussion.topic', {
    url: '?replyId',
    templateUrl: 'community/pages/community-discussion.html',
    controller: 'CommunityDiscussionCtrl',
    controllerAs: 'vm'
  }).state('community.discussion.detail', {
    url: '/discussion/:commentId?replyId',
    templateUrl: 'community/pages/community-discussion-detail.html',
    controller: 'CommunityDiscussionDetailCtrl',
    controllerAs: 'vm',
    resolve: {
      discussion: ['$stateParams', 'discussionSvc', function ($stateParams, discussionSvc) {
        return discussionSvc.getComment($stateParams.commentId);
      }]
    }
  });
}]);